/*
 * @Author: Teemo Ding
 * @Date: 2021-06-25 14:27:12
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 13:09:32
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Invoice/InvoiceInformation/index.tsx
 */
import { Checkbox, Input } from '@/src/components/Antd';
import Configuration from '@/src/components/Configuration/Configuration';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Form } from 'antd';
import React from 'react';
import ImageUpload from '../Components/ImageUpload';
import Label from '../Components/Label';
import css from '../css.module.less';
import { useGetAreaCodeText } from 'src/hooks/useGetAreaCodeText';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
const InvoiceInformation = ({ storeData, disabled, disableEdit }) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    name: storeName = '',
    email = '',
    entityName = '',
    addressLine = '',
    entityRegistrationNumber = '',
    phone,
    areaCode,
    postCode,
    country,
    subdivision,
  } = storeData || {};
  const areaCodeInText = useGetAreaCodeText(areaCode);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      title={getI18n('storeInvoice.detail.invoiceInformation')}
      subtitle={getI18n('storeInvoice.detail.invoiceInformationTip')}>
      {disabled ? null : (
        <React.Fragment>
          <Form.Item
            name='title'
            labelCol={{
              span: 24,
            }}
            rules={[
              {
                required: true,
                message: replaceI18nVariables(
                  getI18n('general.fieldisrequired'),
                  getI18n('storeInvoice.detail.invoiceInformation'),
                ),
              },
            ]}
            label={
              <Label
                title={getI18n('storeInvoice.detail.invoiceTitle') + '*'}
                bottomTitle={getI18n('storeInvoice.detail.invoiceTitleTip')}
              />
            }>
            <Input size='large' className={css.input} disabled={disableEdit} />
          </Form.Item>
          <Form.Item
            name='logo'
            label={
              <Label
                title={getI18n('storeInvoice.detail.logo')}
                bottomTitle={getI18n('storeInvoice.detail.logoTip')}
              />
            }
            labelCol={{
              span: 24,
            }}>
            <ImageUpload disabled={disableEdit}></ImageUpload>
          </Form.Item>
          <div className={css.checkboxBoxContain}>
            <Form.Item
              name='storeNameEnabled'
              valuePropName='checked'
              className={css.checkboxBoxContainItem}>
              <Checkbox className={css.checkboxBox} disabled={disableEdit}>
                <span className={css.checkTitle}>
                  {' '}
                  {getI18n('general.storeName')}
                </span>
                <span>{storeName || '-'}</span>
              </Checkbox>
              {/* */}
            </Form.Item>
            <Form.Item
              name='phoneEnabled'
              valuePropName='checked'
              className={css.checkboxBoxContainItem}>
              <Checkbox className={css.checkboxBox} disabled={disableEdit}>
                <span className={css.checkTitle}>
                  {getI18n('general.customer.phoneNumber')}
                </span>
                <span>
                  +{areaCodeInText} {phone}
                </span>
              </Checkbox>
              {/* <span></span> */}
            </Form.Item>
            <Form.Item
              name='entityNameEnabled'
              valuePropName='checked'
              className={css.checkboxBoxContainItem}>
              <Checkbox className={css.checkboxBox} disabled={disableEdit}>
                <span className={css.checkTitle}>
                  {' '}
                  {getI18n('general.entityName')}
                </span>
                <span>{entityName || '-'}</span>
              </Checkbox>
            </Form.Item>
            <Form.Item
              name='emailEnabled'
              valuePropName='checked'
              className={css.checkboxBoxContainItem}>
              <Checkbox className={css.checkboxBox} disabled={disableEdit}>
                <span className={css.checkTitle}>
                  {getI18n('general.email')}
                </span>
                <span>{email || '-'}</span>
              </Checkbox>
            </Form.Item>
            <Form.Item
              className={css.checkboxBoxContainItem}
              name='entityRegistrationNumberEnabled'
              valuePropName='checked'>
              <Checkbox className={css.checkboxBox} disabled={disableEdit}>
                <span className={css.checkTitle}>
                  {getI18n('general.entityRegistrationNumber')}
                </span>
                <span>{entityRegistrationNumber || '-'}</span>
              </Checkbox>
            </Form.Item>
            <Form.Item
              name='addressEnabled'
              valuePropName='checked'
              className={css.checkboxBoxContainItem}>
              <Checkbox className={css.checkboxBox} disabled={disableEdit}>
                <span className={css.checkTitle}>
                  {getI18n('general.address')}
                </span>
                <span>
                  {addressLine} <br />
                  {(subdivision || {}).name || ''} {(country || {}).name || ''}{' '}
                  {postCode}
                </span>
              </Checkbox>
            </Form.Item>
            <Form.Item
              name='paymentEnabled'
              valuePropName='checked'
              className={css.checkboxBoxContainItem}>
              <Checkbox className={css.checkboxBox} disabled={disableEdit}>
                <span className={css.checkTitle}>
                  {' '}
                  {getI18n('general.paymentInformation')}
                </span>
                <span> {getI18n('storeInvoice.detail.display')}</span>
              </Checkbox>
            </Form.Item>
          </div>
          <Configuration
            configStart={getI18n('storeInvoice.detail.pleasegotoSettings')}
            linkTo={'/settings/storeDetails'}
            configLink={getI18n('storeInvoice.detail.storeDetails')}
            configEnd={getI18n('storeInvoice.detail.toEdit')}
          />
        </React.Fragment>
      )}
    </SectionWrapper>
  );
};
export default InvoiceInformation;
